import { render, staticRenderFns } from "./MenuEditLinkButton.vue?vue&type=template&id=7604a7a8&"
import script from "./MenuEditLinkButton.vue?vue&type=script&lang=ts&"
export * from "./MenuEditLinkButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports